module.exports = __webpack_public_path__ + "img/alentour17.80be2c21.jpg";